import { FETCH_BANNER } from "store/types";

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_BANNER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
